import baseClient from '@/clients/baseClient';

const getAllPrograms = () => baseClient.get('catalogs/programs');
const getAllCompanyManagers = () => baseClient.get('catalogs/company-managers');
const getAllContactPersons = () => baseClient.get('catalogs/contact-persons');
const getStatusesByType = (type) => baseClient.get(`catalogs/statuses/${type}`);
const saveContactPersons = (data) => baseClient.post('catalogs/contact-persons', data);

export default {
    getAllCompanyManagers,
    getAllContactPersons,
    getAllPrograms,
    getStatusesByType,
    saveContactPersons
}